import { slugify } from "cando-util";
import { getBaseURL } from '$lib/utilities/getBaseURL';
import { getSupportedLanguagesAry, translate } from '$lib/utilities/translate';
import { getAreas } from '$lib/utilities/getAreas';
import settings from '$lib/data/generated/content/settings/data.json';
import posts from '$lib/data/generated/content/posts/data.json';
import articles from '$lib/data/generated/content/articles/data.json';
import services from '$lib/data/generated/content/services/data.json';
import locations from '$lib/data/generated/content/locations/data.json';

import { uploads as headUploads } from '$lib/data/generated/uploads/settings/Head/uploads';
import { uploads as headerUploads } from '$lib/data/generated/uploads/settings/Header/uploads';

export const prerender = true;
export const trailingSlash = 'always';

export const load = async ({ url }) => {
	// TODO: I need to keep this out of the renderblocking thread for lighthouse performance score.  The timeout seems to do the trick but I'm not sure there's a better way to do it.
	const timeoutDuration = (url.pathname.includes('/admin/') || url.pathname.includes('/portal/')) ? 0 : 10000;
	setTimeout(async () => {
		const mod = await import('$lib/utilities/fbInit.js');
		await mod.fbInit();  // this has to run clientside I'll bet...
	}, timeoutDuration);

	const baseURL = getBaseURL();

	const uploads = {
		...headUploads,
		...headerUploads
	};

	const content = {
		settings,
		posts,
		articles,
		services,
		locations,
	};

	const data = { baseURL, content, url, uploads };

	const { supportedLanguagesAry, defaultLanguageCode } = getSupportedLanguagesAry();
	const { areaSlugs, defaultArea } = getAreas();

	const path = url.pathname;
	const currentUrlLang = supportedLanguagesAry.map(l => l.code.value).includes(path.split('/')?.[1]) ? path.split('/')?.[1] : defaultLanguageCode;
	const area = areaSlugs.includes(path.split('/')?.[1]) ?
		path.split('/')?.[1] :
		areaSlugs.includes(path.split('/')?.[2]) ?
			path.split('/')?.[2] :
			slugify(defaultArea);

	const currentRawPath = `${path.split('/').filter(pathPart => pathPart !== currentUrlLang).join('/')}`;
	// console.log({ supportedLanguagesAry, currentUrlLang, currentRawPath });

	const lang = currentUrlLang;

	const computePath = (option) => {
		let optionPath = `/${option.value}${currentRawPath}`;
		if (option.value === defaultLanguageCode) {
			optionPath = `${currentRawPath}`;
		}
		// console.log({ optionPath });

		return optionPath;
	};

	data.languageOptions = supportedLanguagesAry.map((l) => ({
		option: l.labelFlag.value,
		value: l.code.value,
		label: translate(l.label, lang),
		path: computePath({ value: l.code.value }),
		dir: l.dir?.value
	}));

	data.currentLanguageOption = data.languageOptions.filter((o) => o.value === lang)?.[0];

	return { ...data, lang, area };
};
